export enum EstadoPedidoMonitoreo {
    Pendiente = 0,
    Asignado = 1,
    Precargado = 2,
    Cargado = 3,
    Prioridad = 4    
}
